import { apiService } from './api';
import { Expense, CreateExpenseRequest, ExpenseFilters, PnlReport } from '../types/expense';

export const expenseService = {
  async getExpenses(filters: ExpenseFilters): Promise<Expense[]> {
    const response = await apiService.get<Expense[]>('/expenses', filters);
    return response.data;
  },

  async createExpense(data: CreateExpenseRequest): Promise<Expense> {
    const response = await apiService.post<Expense>('/expenses', data);
    return response.data;
  },

  async updateExpense(id: string, data: Partial<CreateExpenseRequest>): Promise<Expense> {
    const response = await apiService.put<Expense>(`/expenses/${id}`, data);
    return response.data;
  },

  async deleteExpense(id: string): Promise<void> {
    await apiService.delete(`/expenses/${id}`);
  },

  async getPnl(org: string, restaurantId: string | undefined, start: string, end: string): Promise<PnlReport> {
    const response = await apiService.get<PnlReport>('/expenses/pnl', {
      org, ...(restaurantId && { restaurantId }), start, end,
    });
    return response.data;
  },
};
